export default __webpack_public_path__ + "static/media/wound_image_not_process.f6f6ca09.png";